// extracted by mini-css-extract-plugin
export default {"avatarContainer":"avatar_avatarContainer__R8Fcl","placeholder":"avatar_placeholder__NQeRM","placeholderSpan":"avatar_placeholderSpan__pNkXc"};